import React, { forwardRef } from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

export const IconPdf = forwardRef((props, ref) => (
  <SvgIcon
    {...props}
    ref={ref}
    viewBox="0 0 20 20"
    data-fill-none
  >
    <path
      d="M9.82355 3.1733C9.48771 1.2618 6.6881 1.3691 6.87015 3.74032C7.05221 6.11153 12.7076 12.5539 15.6495 13.6721C18.5913 14.7903 18.8586 12.1012 16.5597 11.3298C14.2608 10.5583 6.60134 13.2518 3.40845 14.9466C0.215571 16.6413 2.8494 19.3602 4.51755 17.5763C6.1857 15.7924 10.1365 4.95419 9.82355 3.1733Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
));
